document.addEventListener('DOMContentLoaded', () => {
  const countPerPage = document
    .querySelector('#AjaxinateLoop')
    .getAttribute('data-count')
  let countClickMore = 1
  const loadMoreBtn = document.querySelector('#AjaxinatePagination button')
  const allArticles = document.querySelectorAll(
    '#AjaxinateLoop .blog-articles__article'
  )
  const filterBtns = document.querySelectorAll('.all-blogs .blog__tag-item')
  let queryArr = []

  showArticles()

  loadMoreBtn.addEventListener('click', () => {
    countClickMore++
    showArticles()
  })

  filterBtns.forEach(btn => {
    let tag = btn.getAttribute('data-tag')
    btn.addEventListener('click', () => {
      if (btn.classList.contains('current')) {
        queryArr = queryArr.filter(elem => elem !== tag)
        btn.classList.remove('current')
      } else {
        queryArr.push(tag)
        btn.classList.add('current')
      }
      countClickMore = 1
      showArticles()
    })
  })

  function showArticles () {
    if (queryArr.length > 0) {
      let matchedCount = 0
      allArticles.forEach(article => {
        let tags = article.getAttribute('data-tags')
        let isMatch = true
        queryArr.forEach(q => {
          if (!tags.includes(q)) isMatch = false
        })

        if (matchedCount <= countPerPage * countClickMore - 1 && isMatch) {
          article.style.display = 'block'
        } else {
          article.style.display = 'none'
        }

        if (isMatch) {
          matchedCount++
        }
      })

      matchedCount <= countPerPage * countClickMore
        ? (loadMoreBtn.style.display = 'none')
        : (loadMoreBtn.style.display = 'flex')
    } else {
      allArticles.forEach((article, index) => {
        if (index <= countPerPage * countClickMore - 1) {
          article.style.display = 'block'
        } else {
          article.style.display = 'none'
        }
      })

      allArticles.length <= countPerPage * countClickMore
        ? (loadMoreBtn.style.display = 'none')
        : (loadMoreBtn.style.display = 'flex')
    }
  }
})
